
import Vue from 'vue'
import BaseButton from './BaseButton.vue'
export default Vue.extend({
   name: 'SaveButton',
   props: {
      label: { default: 'Save', type: String },
      actionLabel: { default: 'Saving', type: String },
      showIcon: { default: false, type: Boolean },
      icon: { default: 'glyphicon-ok', type: String },
      type: { default: 'btn-default', type: String },
      size: { default: '', type: String },
      enabled: { default: true, type: Boolean },
      saving: { default: false, type: Boolean },
   },
   components: {
      BaseButton,
   },
})
